<!-- 大屏链接 -->
<template>
  <div class="screen-container" @dblclick="handleScreenFull">
    <div class="header">
      <div class="terminal-logo">
        <el-image :src="logo.terminalLogo" />
        <span>{{ info | objValue('stationName') }}</span>
      </div>
      <div class="installer-logo">
        <el-image :src="logo.installerLogo" />
      </div>
    </div>
    <div class="main">
      <div class="left-content">
        <section>
          <h4 class="title">实时功率</h4>
          <div class="content real-power">
            <LiquidChart :data="power.rate" style="width:100%" />
            <div class="value-descript">
              <p><b>实时功率</b> <span>{{ overview | objValue('power') | unit('kW') }}</span></p>
              <p><b>装机容量</b> <span>{{ overview | objValue('capacity') | unit('kWp') }}</span></p>
              <hr>
              <p><b>日满发小时</b> <span>{{ overview | objValue('dayFull') | unit('h') }}</span></p>
              <p><b>月满发小时</b> <span>{{ overview | objValue('monthFull') | unit('h') }}</span></p>
            </div>
          </div>
        </section>
        <section>
          <h4 class="title">电站产出</h4>
          <div class="content station-output">
            <PieChart :data="power.totalPower" text="总电量" unit="kWh" style="width:100%" />
            <div class="value-descript">
              <p class="yellow">
                <b>今日发电量</b>
                <br>
                <span>{{ overview.dmtEnergys | objValue(['dayEnergy', 'f', 'cvalue'], 0) }}{{ overview.dmtEnergys |
                  objValue(['dayEnergy', 'f', 'cvalue'], 1)}}</span>
              </p>
              <p class="blue">
                <b>本月发电量</b>
                <br>
                <span>{{ overview.dmtEnergys | objValue(['monthEnergy', 'f', 'cvalue'], 0) }}{{ overview.dmtEnergys |
                  objValue(['monthEnergy', 'f', 'cvalue'], 1)}}</span>
              </p>
            </div>
          </div>
        </section>
        <section>
          <h4 class="title">电站收益</h4>
          <div class="content station-income">
            <PieChart :data="power.totalIncome" text="总收益" unit="元" style="width:100%" />
            <div class="value-descript">
              <p class="yellow"><b>今日收益</b> <br> <span>{{ overview | objValue('dayIncome') | unit('元') }}</span></p>
              <p class="blue"><b>本月收益</b> <br> <span>{{ overview | objValue('monthIncome') | unit('元') }}</span></p>
            </div>
          </div>
        </section>
      </div>
      <div class="middle-content">
        <section class="top-container">
          <div class="title-container">
            <h4 class="title">能量平衡</h4>
            <div class="button-group" style="display: flex;">
              <button :class="dateType === 'day' ? 'active' : ''" @click="changeDataType('day', 0)">日</button>
              <button :class="dateType === 'month' ? 'active' : ''" @click="changeDataType('month', 1)">月</button>
              <button :class="dateType === 'year' ? 'active' : ''" @click="changeDataType('year', 2)">年</button>
              <button :class="dateType === 'total' ? 'active' : ''" @click="changeDataType('total', 3)">总</button>
            </div>
          </div>
          <div class="content-container">
            <div>
              <ToggleChart
                :data="chart2.data"
                :columns="chart2.columns"
                :format="chart2.format"
                :setting="chart2.setting"
                :extend="chart2.extend"
                :loading="chart2.loading"
                :unit="chart2.unit"
              />
            </div>
            <div>
              <ToggleChart
                :data="chart1.data"
                :columns="chart1.columns"
                :format="chart1.format"
                :setting="chart1.setting"
                :extend="chart1.extend"
                :loading="chart1.loading"
                :unit="chart1.unit"
              />
            </div>
          </div>
        </section>
        <div class="bottom-container">
          <section>
            <h4 class="title">发电量{{ power.ftotal | unit('kWh') }}</h4>
            <div class="content">
              <bar left-text="光伏发电自用" right-text="卖电电量" :data="power.faData" :color="['#FAB534', '#4C8FF0']" />
            </div>
          </section>
          <section>
            <h4 class="title">用户用电量{{ power.rtotal | unit('kWh') }}</h4>
            <div class="content">
              <bar left-text="用户自发自用" right-text="买电电量" :data="power.yoData" :color="['#62BE95', '#DC6170']" />
            </div>
          </section>
        </div>
      </div>
      <div class="right-content">
        <section>
          <h4 class="title">电站信息 <span>{{ time }}</span></h4>
          <div class="content station-info">
            <h4>{{ info | objValue('stationName') }}</h4>
            <div class="value-descript">
              <p><b>电站状态</b> <span>{{ info | objValue('status') | statusFilter }}</span></p>
              <p><b>电站类型</b> <span>{{ info | objValue('orgtype') }}</span></p>
              <p><b>并网时间</b> <span>{{ info | objValue('gctime') | dateFilter('yyyy-MM-dd') }}</span></p>
              <p><b>电站地址</b> <span>{{ info | objValue('city') }}</span></p>
            </div>
          </div>
        </section>
        <section class="weather-info">
          <div>
            <h4 class="title" style="padding-left: 15px;">天气信息</h4>
            <div class="content weather-params">
              <div>
                <p>湿度</p>
                <span>{{ weather | objValue('humidity') | unit('%RH') }}</span>
              </div>
              <div>
                <p>气温</p>
                <span>{{ weather | objValue('temperature') | unit('℃') }}</span>
              </div>
              <div>
                <p>风速</p>
                <span>{{ weather | objValue('windspeed') | unit('m/s') }}</span>
              </div>
              <div>
                <p>风向</p>
                <span>{{ weather | objValue('winddesc') }}</span>
              </div>
            </div>
          </div>
          <div>
            <h4 class="title" style="padding-left: 15px;">天气预报</h4>
            <div class="content weather-forecast">
              <div v-for="(item, index) in weather.weather" :key="index" class="item">
                <span>{{ JSON.parse(item).tempMin | unit('℃') }}~{{ JSON.parse(item).tempMax | unit('℃') }}</span>
                <i :class="getClass(JSON.parse(item).iconDay)" />
                <span>星期{{ JSON.parse(item).fxDate | weekFilter }}</span>
              </div>
            </div>
          </div>
        </section>
        <section>
          <h4 class="title">节能减排</h4>
          <div class="content energy-conservation">
            <div>
              <el-image :src="require('@/assets/bigscreen/co.png')" />
              <p>CO2减排</p>
              <p>{{ overview | objValue('safeCO2') | unit('t') }}</p>
            </div>
            <div>
              <el-image :src="require('@/assets/bigscreen/tree.png')" />
              <p>等效绿植</p>
              <p>{{ overview | objValue('safeTrees') | unit('棵') }}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import screenfull from 'screenfull/dist/screenfull.js'
import LiquidChart from '@views/Charts/LiquidChart2.vue'
import ToggleChart from '@views/Charts/ToggleChart4.vue'
import PieChart from '@views/Charts/PieChart2.vue'
import bar from './component/bar.vue'
import {
  MeterStationInfo,
  GetMeterStationOverviewData, GetCompanyInfo, GetWeatherReal, GetEnergyOverviewData,
  GetEnergyChartData
} from '@apis/TV.js'
export default {
  components: {
    LiquidChart,
    PieChart,
    ToggleChart,
    bar
  },
  data () {
    return {
      timer: null,
      timer2: null,
      timer3: null,
      time: '',
      logo: {},
      logo1: require('@/assets/bigscreen/logo2.png'),
      logo2: require('@/assets/bigscreen/logo1.png'),
      // 实时功率水波图
      power: {
        faData: [0, 0],
        yoData: [0, 0],
        rtotal: 0,
        ftotal: 0,
        rate: 0,
        totalPower: 0,
        totalIncome: 0
      },
      info: {}, // 电站信息
      overview: {}, // 概览信息
      dateType: 'day',
      active: 0,
      weather: {},
      chart1: { // 能量平衡发电图表
        loading: false,
        columns: [],
        data: [],
        format: '',
        unit: 'kW',
        setting: {
          type: 'line', area: true, labelMap: {
            'val1': '发电功率', 'val2': '自发自用', 'val3': '卖电功率'
          }
        },
        extend: {
          title: {
            text: '发电',
            right: 40,
            top: 0,
            textStyle: {
              color: '#f8f8f8'
            }
          }
        }
      },
      chart2: { // 能量平衡用电图表
        loading: false,
        columns: [],
        data: [],
        format: '',
        unit: 'kW',
        setting: {
          type: 'line', area: true, stack: { '总': ['val1', 'val2'] }, labelMap: {
            'val1': '用电功率', 'val2': '自发自用', 'val3': '买电功率'
          }
        },
        extend: {
          title: {
            text: '用电',
            right: 40,
            top: 0,
            textStyle: {
              color: '#f8f8f8'
            }
          },
          legend: {
            bottom: 0,
            textStyle: {
              color: '#f8f8f8'
            }
          },
          grid: {
            left: 40,
            right: 40,
            bottom: 30,
            top: 40
          },
        }
      },

      orgid: ''
    }
  },
  created () {
    this.orgid = this.$route.params.id === '734786da07974e14a44e65d7556afeeb' ? 'ac293922c7154cc69526834813f83b41' : this.$route.params.id
    this.timer = setInterval(() => {
      this.time = this.$parseTime(new Date(), 'yyyy-MM-dd hh:mm:ss')
    }, 1000)
    this.timer2 = setInterval(() => {
      this.getOverviewData()
      this.getInfo()
      this.getWeather()
    }, 1000 * 60 * 5)
    this.timer3 = setInterval(() => {
      const type = ['day', 'month', 'year', 'total']
      this.active++
      if (this.active >= 4) {
        this.active = 0
      }
      this.dateType = type[this.active]
      this.getPowerData()
      this.getBalanceChartData()
    }, 30 * 1000)
    this.getInfo()
    this.getBalanceChartData()
    this.getOverviewData()
    this.getLogo()
    this.getWeather()
    this.getPowerData()
  },
  beforeDestroy () {
    if (this.timer) {
      clearInterval(this.timer)
    }
    if (this.timer2) {
      clearInterval(this.timer2)
    }
    if (this.timer3) {
      clearInterval(this.timer3)
    }
  },
  methods: {
    // 全屏切换
    handleScreenFull () {
      if (screenfull.isEnabled) {
        screenfull.toggle()
      }
    },
    // 获取电站信息
    getInfo () {
      MeterStationInfo({
        id: this.orgid
      }).then(({ data }) => {
        this.info = data
      })
    },
    // 改变日期类型
    changeDataType (type, index) {
      this.dateType = type
      this.active = index
      this.getPowerData()
      this.getBalanceChartData()
    },
    // 能量平衡发电图表
    getBalanceChartData () {
      this.chart1.loading = true
      this.chart2.loading = true
      this.chart1.columns = []
      this.chart1.data = []
      this.chart2.columns = []
      this.chart2.data = []
      let st, et
      if (this.dateType === 'day') {
        st = this.$parseTime(new Date(), 'yyyy-MM-dd') + ' 00:00:00'
        et = this.$parseTime(new Date(), 'yyyy-MM-dd') + ' 23:59:59'
        this.chart1.columns = ['time', 'solar', 'selfuse', 'sell']
        this.chart2.columns = ['time', 'use', 'selfuse', 'buy']
        delete this.chart1.setting.stack
        delete this.chart2.setting.stack
        this.chart1.setting.type = 'line'
        this.chart2.setting.type = 'line'
        this.chart1.unit = 'kW'
        this.chart2.unit = 'kW'
        this.chart1.setting.labelMap = {
          'solar': '发电功率', 'selfuse': '自发自用', 'sell': '卖电功率'
        }
        this.chart2.setting.labelMap = {
          'use': '用电功率', 'selfuse': '自发自用', 'buy': '买电功率'
        }
        this.chart1.format = 'hh:mm'
        this.chart2.format = 'hh:mm'
      } else if (this.dateType === 'month') {
        st = this.$parseTime(new Date(), 'yyyy-MM-01') + ' 00:00:00'
        et = this.$parseTime(new Date(), 'yyyy-MM-') + this.$gmt(new Date()) + ' 23:59:59'
        this.chart1.columns = ['time', 'sell', 'selfuse']
        this.chart1.setting.type = 'histogram'
        this.chart1.unit = 'kWh'
        this.chart1.setting.labelMap = {
          'sell': '卖电电量', 'selfuse': '自发自用'
        }
        this.chart1.setting.stack = { '总': ['sell', 'selfuse'] }
        this.chart1.format = 'yyyy-MM-dd'

        this.chart2.columns = ['time', 'buy', 'selfuse']
        this.chart2.setting.type = 'histogram'
        this.chart2.unit = 'kWh'
        this.chart2.setting.labelMap = {
          'buy': '买电电量', 'selfuse': '自发自用'
        }
        this.chart2.setting.stack = { '总': ['buy', 'selfuse'] }
        this.chart2.format = 'yyyy-MM-dd'
      } else if (this.dateType === 'year') {
        st = this.$parseTime(new Date(), 'yyyy-01-01') + ' 00:00:00'
        et = this.$parseTime(new Date(), 'yyyy-12-31') + ' 23:59:59'

        this.chart1.columns = ['time', 'sell', 'selfuse']
        this.chart1.setting.type = 'histogram'
        this.chart1.unit = 'kWh'
        this.chart1.setting.stack = { '总': ['sell', 'selfuse'] }
        this.chart1.setting.labelMap = {
          'sell': '卖电电量', 'selfuse': '自发自用'
        }
        this.chart1.format = 'yyyy-MM'
        this.chart2.columns = ['time', 'buy', 'selfuse']
        this.chart2.setting.type = 'histogram'
        this.chart2.unit = 'kWh'
        this.chart2.setting.labelMap = {
          'buy': '买电电量', 'selfuse': '自发自用'
        }
        this.chart2.setting.stack = { '总': ['buy', 'selfuse'] }
        this.chart2.format = 'yyyy-MM'
      } else if (this.dateType === 'total') {
        st = null
        et = null
        this.chart1.setting.type = 'histogram'
        this.chart1.unit = 'kWh'
        this.chart1.setting.stack = { '总': ['sell', 'selfuse'] }
        this.chart1.setting.labelMap = {
          'sell': '卖电电量', 'selfuse': '自发自用'
        }
        this.chart1.columns = ['time', 'sell', 'selfuse']
        this.chart1.format = 'yyyy'

        this.chart2.columns = ['time', 'buy', 'selfuse']
        this.chart2.setting.type = 'histogram'
        this.chart2.unit = 'kWh'
        this.chart2.setting.labelMap = {
          'buy': '买电电量', 'selfuse': '自发自用'
        }
        this.chart2.setting.stack = { '总': ['buy', 'selfuse'] }
        this.chart2.format = 'yyyy'
      }
      GetEnergyChartData({
        dateType: this.dateType,
        startTime: st,
        endTime: et,
        orgId: this.orgid
      })
        .then(res => {
          this.chart1.loading = false
          this.chart2.loading = false
          this.chart1.data = res.data
          let count = 0
          let lastCount = 0
          if (this.chart1.data.length > 24) {
            count = this.chart1.data.findIndex(o => {
              return (o.solar + o.selfuse + o.sell) !== 0
            })
            lastCount = this.chart1.data.reverse().findIndex(o => {
              return (o.solar + o.selfuse + o.sell) !== 0
            })
            this.chart1.data.reverse()
          }
          if (count > 24 && this.dateType === 'day') {
            this.chart1.data = this.chart1.data.slice(count - 24)
          }
          if (lastCount > 24 && this.dataType === 'day') {
            this.chart1.data = this.chart1.data.slice(0, this.chart1.data.length - (lastCount - 24))
          }
          this.chart2.data = res.data
        })
        .catch(() => {
          this.chart1.columns = []
          this.chart2.columns = []
          this.chart1.loading = false
          this.chart2.loading = false
        })
    },
    // 获取概览信息
    getOverviewData () {
      GetMeterStationOverviewData({ id: this.orgid })
        .then(res => {
          this.overview = res.data
          this.power.rate = res.data.power / res.data.capacity
          this.power.totalPower = res.data.dmtEnergys.totalEnergy.f.orivalue
          this.power.totalIncome = res.data.totalIncome
        })
    },
    // 获取logo
    getLogo () {
      GetCompanyInfo({ id: this.orgid }).then(({ data }) => {
        this.logo = data
      })
    },
    // 获取天气数据
    getWeather () {
      GetWeatherReal({ id: this.orgid }).then(({ data }) => {
        const firstDay = JSON.parse(data.weather[0])
        data.humidity = firstDay.humidity
        data.temperature = firstDay.tempMax
        data.winddesc = firstDay.windDirDay
        data.windspeed = firstDay.windSpeedDay
        this.weather = data
      })
    },
    // 获取发电用域用电量数据
    getPowerData () {
      GetEnergyOverviewData({
        dateType: this.dateType,
        orgId: this.orgid
      }).then(res => {
        this.power.rtotal = res.data.rtotal
        this.power.ftotal = res.data.ftotal
        this.power.faData[0] = res.data.spontaneousselfuse
        this.power.faData[1] = res.data.electricitysales
        this.power.yoData[0] = res.data.yspontaneousselfuse
        this.power.yoData[1] = res.data.electricquantitypurchased
      })
    },
    // 获取天气类型
    getClass (type) {
      return 'qi-' + type
    }
  }
}
</script>

<style>
@import './dingwei.css';
</style>
